module.exports = __webpack_public_path__ + "img/680-3f8275.png";